import { Box, Spinner, Text, VStack } from "@chakra-ui/react";

const LoadingSpinner = ({
  message = "ගෙවීම සම්පූර්ණ වන තුරු රැඳී සිටින්න...",
}) => {
  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
    >
      <VStack spacing={4}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text fontSize="3xl" color="red.500">
          {message}
        </Text>
      </VStack>
    </Box>
  );
};

export default LoadingSpinner;
